import { render } from "./Report.vue?vue&type=template&id=42fd3c5b&scoped=true"
const script = {}

import "./Report.vue?vue&type=style&index=0&id=42fd3c5b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fd3c5b"]])

export default __exports__